import { render, staticRenderFns } from "./CustomMagdalenaMethods.vue?vue&type=template&id=e5667afe&"
import script from "./CustomMagdalenaMethods.vue?vue&type=script&lang=js&"
export * from "./CustomMagdalenaMethods.vue?vue&type=script&lang=js&"
import style0 from "./CustomMagdalenaMethods.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports